import { Component, Inject, forwardRef, Injector, OnInit, ViewChild, ElementRef, Renderer2, Input } from '@angular/core';
import { AppComponent } from './app.component';
import { ApiService } from './shared/api.service';
import { Router } from '@angular/router';
import { PageService } from './shared/pages.service';
import { NotificationService } from './menu-popups/notifications/notification.service';
import { UtilitiesService } from './utils/utilities.service';
import { ChatService } from './ws-services/chat.service';
import { AutoLogoutService } from './utils/auto-logout.service';
import { environment } from '../environments/environment';
import { PrivilegeService } from './shared/privilege.service';
import { AuthService } from './shared/auth.service';
import { ThemeingService } from './utils/themeing.service';
import { PlatformLocation } from '@angular/common';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { AlertService } from './shared/alert.service';
import CryptoJS from "crypto-js";
// import { JSEncrypt } from 'jsencrypt';
@Component({
	selector: 'app-topbar',
	templateUrl: './app.topbar.component.html',
	styleUrls: ['./app.component.scss']
})
export class AppTopBarComponent implements OnInit {
	isApplicationFee = false;
	user: any = {};
	isOpsUser: boolean = false;
	title: string = "";
	parentComponent: any;
	nonifList: any;
	isAddNewCase = false;
	isEditProfile = false;
	isNotifications = false;
	loginUser: any = {};
	defaultWelcomePage = '';
	matched = false;
	pages: any = [];
	filter: any = {};
	obj: object = {};
	loading = false;
	unReadCount = 0;
	totalCount = 0;
	time: any;
	time1: any;
	notifCreatedTime: any;
	currentDate: any;
	currentTime: any;
	hourDiff: any;
	diffDays: any;
	isExportedFilesLog = false;
	msg: any;
	displayExtFileLog = false;
	riskPages: any[] = [];
	dmpPages: any[] = [];
	opsPages: any[] = [];
	manageStaticPages: any[] = [];
	quantPagescol1: any[] = [];
	quantPagescol2: any[] = [];
	quantPagescol3: any[] = [];
	settingsPages: any[] = [];
	salesTeamPages: any[] = [];
	pAndLPages: any[] = [];
	extAumPages: any[] = [];
	reportPages: any[] = [];
	investPages: any[] = [];
	itPages: any[] = [];
	tpsPages: any = {
		tpsTradeBlotterPages: [] as any[],
		tpsStaticPages: [] as any[],
		tpsMessageHubPages: [] as any[],
		tpsConfigPages: [] as any[]
	}

	fairvalue = false;
	accountmaintain = false;
	isRates = false;
	showAccMaping = false;
	isTradeDates = false;
	@Input() selectpath: any

	showSessionExpired = false;
	confirmDefaultHome = false;
	selectedPage: any;
	customHeader: any;
	isLoading = false;
	isSelectedWelcomePageAvailable = false;
	landingLogo = '';
	client = this.themeingService.getClientName();

	canCreateNewCase = { 'screenName': 'CaseCreate', 'subModule': 'canCreateNewCase' };
	canViewTradeDatesPriv = { 'screenName': 'Quant', 'subModule': 'canViewTradeDates' };
	canViewFxRatePriv = { 'screenName': 'Quant', 'subModule': 'canViewFxRate' };
	canAdjustFairValuePriv = { 'screenName': 'Quant', 'subModule': 'canAdjustFairValue' };
	canViewAccMapPriv = { 'screenName': 'Quant', 'subModule': 'canViewAccMap' };
	canViewBkIntrstMntncePriv = { 'screenName': 'Quant', 'subModule': 'canViewBkIntrstMntnce' };
	canViewFeeMntncePriv = { 'screenName': 'Quant', 'subModule': 'canViewFeeMntnce' };
	canViewExpFilesLogPriv = { 'screenName': 'Quant', 'subModule': 'canViewExpFilesLog' };

	@ViewChild('menuContainer', { static: false }) menuContainer!: ElementRef;
	path: string = "";
	newsLetterPages: any = []
	configPages: any = []
	dcPages: any = []

	constructor(@Inject(forwardRef(() => AppComponent)) public app: AppComponent,
		public chatService: ChatService,
		public apiService: ApiService,
		private router: Router,
		public injector: Injector,
		private pageService: PageService,
		public autoLogoutService: AutoLogoutService,
		public privilegeService: PrivilegeService,
		private notificationService: NotificationService,
		private renderer: Renderer2,
		private authService: AuthService,
		private themeingService: ThemeingService,
		private location: PlatformLocation,
		private http: HttpClient,
		private alertService: AlertService
	) {
		chatService.messages.subscribe(msg => { this.getNotifications(msg); });

		// Hiding Menu and Notif list on click browser back button.
		location.onPopState(() => {
			this.parentComponent.topbarMenuActive = false;
			this.parentComponent.notifMenuActive = false;
		});
	}



	logout() {
		this.authService.logoutS()
	}

	search(val: any) {
		if ((val == 'aum') || (val == 'nav') || (val == 'AUM') || (val == 'NAV') || (val == 'Aum') || (val == 'Nav')) {
			this.router.navigate(['/datamarketplacereports'])
		}
	}

	ngOnInit() {
		this.title = environment[window.location.hostname].title;
		this.parentComponent = this.injector.get(AppComponent);
		this.loginUser = this.parentComponent.authService.currentUser();
		if (this.loginUser) {
			this.defaultWelcomePage = this.loginUser['defaultWelcomePage'];
		}
		if (this.defaultWelcomePage === undefined || this.defaultWelcomePage === null) {
			this.defaultWelcomePage = '';
		}
		this.landingLogo = (this.client === 'CSOP' ? 'assets/icons/large-home.svg' : 'assets/icons/large-home-tec.svg')
		localStorage.setItem('defaultWelcomePage', this.defaultWelcomePage);
		this.handleNotifAndUsers();
		this.setWelcomePageWhenNA();
		this.getManageStaticData();
		const canAccessOpsDashboard = { 'screenName': 'OPS', 'subModule': 'canAccessOpsDashboard' };
		if (this.privilegeService.isAuthorized(canAccessOpsDashboard)) {
			this.isOpsUser = true;
		}
	}

	getTitle() {
		return environment[window.location.hostname].defaultTitle + ' ' + environment[window.location.hostname].envType;
	}

	getLogo() {
		return this.themeingService.getIcon('logoURL');
	}

	handleNotifAndUsers() {
		this.pages = this.pageService.pages();
		const cachedCurrentUser: any = localStorage.getItem('currentUser');
		this.user = JSON.parse(cachedCurrentUser);
		this.parentComponent = this.injector.get(AppComponent);
		this.msg = {};
		this.getNotifications(this.msg);
	}

	handleMenuClick(event: Event) {
		const domElement = this.menuContainer.nativeElement;
		this.app.onTopbarMenuButtonClick(event);
		setTimeout(() => {
			if (domElement.scrollTop > 0) {
				this.renderer.setProperty(domElement, 'scrollTop', 0);
			}
		}, 20);
	}

	onMenuClick(url: string) {
		if (url === '/holiday-scheduler') {
			this.parentComponent.topbarMenuActive = false;
			// this.openHolidayScheduler();
			return;
		}
		if (url === '/newsletters') {
			localStorage.removeItem('newsletterAction');
		}
		this.parentComponent.topbarMenuActive = false;
		this.router.navigate([url]);
	}

	// /**
	// * AES加密
	// * @param word
	// * @param key
	// * @param iv
	// * @returns
	// */
	// encrypt(word: string) {
	// 	const keys = CryptoJS.enc.Utf8.parse('0000000000000000');
	// 	const ivs = CryptoJS.enc.Utf8.parse('0000000000000000');
	// 	const srcs = CryptoJS.enc.Utf8.parse(word);
	// 	const encrypted = CryptoJS.AES.encrypt(srcs, keys, {
	// 		iv: ivs,
	// 		mode: CryptoJS.mode.CBC,
	// 		padding: CryptoJS.pad.Pkcs7,
	// 	});
	// 	return encrypted.ciphertext.toString();
	// }

	// /**
	// * RSA encrypt
	// * @param data
	// * @returns
	// */
	// encryptRSA(data) {
	// 	let publicKey = environment[window.location.hostname].publicKey;
    //     const encryptTool = new JSEncrypt()
	// 	encryptTool.setPublicKey(publicKey);
	// 	return encryptTool.encrypt(data);
	// }

	// onMenuClickOpenNewWindow(url: string, withToken = false) {
	// 	// don't worry token expose. we will delete it when enter ycmp-auth-center(yinghe)
	// 	let rootUrl = environment[window.location.hostname].investUrl;
	// 	window.location.assign(withToken ? `${rootUrl}?token=${this.encrypt(JSON.parse(localStorage.getItem('currentUser'))?.token ?? '')}` : rootUrl);
	// }

	// onMenuClickOpenNewWindowForReport(url: string) {
	// 	let rootUrl = environment[window.location.hostname].reportUrl;
	// 	let userEmail = JSON.parse(localStorage.getItem('currentUser')).email;
	// 	let userName = userEmail.split("@") ? userEmail.split("@")[0] : '';
    //     // for Ding zong and zhang bo. Their user name are not follow regular rule
    //     if (userName === 'chen.ding') {
	// 		userName = 'DingChen';
    //     } else if (userName === 'bo.zhang') {
	//         userName = 'zhangbo';
    //     } else if (userName === 'alessandro.zhu@csopasset.com ') {
	//         userName = 'Alessandrozhu';
    //     }
    //     userName = userName.replace('.','');
	// 	let encryptUsername = this.encryptRSA(userName);
	// 	let encodeUserName = encodeURIComponent(encryptUsername);
	// 	window.location.assign(`${rootUrl}?ssoToken=${encodeUserName}`);
	// }

	onClickFeeMaintenance() {
		this.isApplicationFee = true;
	}

	viewAll() {
		this.isNotifications = true;
	}

	addNewCase() {
		this.isAddNewCase = true;
	}

	getNotifications(msg: any) {
		this.filter['sortBy'] = { 'createdAt': 'desc' };
		this.notificationService.find(this.filter).then((data: any) => {
			this.nonifList = data['notificationList'];
			this.nonifList.forEach((element: any) => {
				this.time = new Date(element.createdAt);
				this.currentDate = new Date();
				this.time1 = new Date();
				this.notifCreatedTime = new Date(Date.UTC(this.time.getFullYear(),
					this.time.getMonth(),
					this.time.getDate(),
					this.time.getHours(),
					this.time.getMinutes(),
					this.time.getSeconds()));
				this.currentTime = new Date(this.time1.setTime(this.time1.getTime() + (30 * 60 * 1000) + (5 * 60 * 60 * 1000)));
				this.diffDays = this.currentTime.getDate() - this.notifCreatedTime.getDate();
				element.showTime = UtilitiesService.setLoginAndCaseUpdatedTime(this.notifCreatedTime, this.currentTime);
			});
			this.unReadCount = data['unread'];
			this.totalCount = data['totalRecords'];
			this.loading = false;
			if (msg.message) {
				this.formatAndReturnTheMessage(msg.message);
				this.parentComponent.messageService.add({
					severity: 'success', detail: '<span>' + msg.firstName +
						'</span>' + ' ' + this.formatAndReturnTheMessage(msg.message)
				});
			}
		}).catch(err => {
		});
	}

	onClickProfile() {
		this.parentComponent.topbarMenuActive = false;
		this.isEditProfile = true;
	}

	onClickExportFileLog() {
		this.parentComponent.topbarMenuActive = false;
		this.displayExtFileLog = true;
	}

	formatAndReturnTheMessage(message: string) {
		return message ? message.replace('USER ', '') : message;
	}

	readNotif(notifCase: any) {
		this.obj = { 'noticeId': notifCase['noticeId'] };
		this.notificationService.update(this.obj).then((data: any) => {
			if (data['status'] === 'success') {
				this.nonifList.forEach((element: any) => {
					if (element.noticeId === notifCase.noticeId) { element.readFlag = '1'; }
				});
				if (this.unReadCount > 0) { this.unReadCount = this.unReadCount - 1; }
			} else {
				this.parentComponent.messageService.add({ severity: 'error', detail: data['status'] });
			}
		}).catch(err => {
			this.parentComponent.messageService.add({ severity: 'error', detail: err });
		});
	}

	ContinueWorking() {
		this.autoLogoutService.reset();
	}

	userLogout() {
		this.authService.logoutS()
		window.location.reload();
	}

	onClickLogo() {
		this.router.navigate(['/dashboard']);
	}
	OnClickAdvSearch() {
		this.router.navigate(['/datamarketplacedetails'])
	}

	private setWelcomePage(element: any) {
		if (this.defaultWelcomePage === '') {
			this.defaultWelcomePage = element.routerLink;
			localStorage.setItem('defaultWelcomePage', this.defaultWelcomePage);
		} else if (this.defaultWelcomePage === element.routerLink) {
			this.isSelectedWelcomePageAvailable = true;
		}
	}

	private setWelcomePageWhenNA() {
		if (!this.isSelectedWelcomePageAvailable) {
			let itemsToCheckFrom = [];
			if (this.riskPages.length > 0) { itemsToCheckFrom = this.riskPages; }
			else if (this.newsLetterPages.length > 0) { itemsToCheckFrom = this.newsLetterPages; }
			else if (this.configPages.length > 0) { itemsToCheckFrom = this.configPages; }
			else if (this.dcPages.length > 0) { itemsToCheckFrom = this.dcPages; }
			else if (this.dmpPages.length > 0) { itemsToCheckFrom = this.dmpPages; }
			else if (this.opsPages.length > 0) { itemsToCheckFrom = this.opsPages; }
			else if (this.quantPagescol1.length > 0) { itemsToCheckFrom = this.quantPagescol1; }
			else if (this.quantPagescol2.length > 0) { itemsToCheckFrom = this.quantPagescol2; }
			else if (this.quantPagescol3.length > 0) { itemsToCheckFrom = this.quantPagescol3; }
			if (itemsToCheckFrom.length > 0) {
				this.defaultWelcomePage = itemsToCheckFrom[0]?.routerLink;
				localStorage.setItem('defaultWelcomePage', this.defaultWelcomePage);
			}
		}
	}

	private getWelcomePage(currentPage: any): string {
		const defaultWelcomePage = localStorage.getItem('defaultWelcomePage');
		if (!defaultWelcomePage || (defaultWelcomePage === currentPage)) { return '/'; }
		return defaultWelcomePage + '/';
	}

	isAllowedToViewMenu(menuHeader: string): boolean {
		let itemsToIterate: any[] = [];
		switch (menuHeader) {
			case 'OPS':
				itemsToIterate = ['OPS_DASHBOARD', 'ACCOUNT_MAPPING', 'RECON_CONFIGURATION'];
				this.getOpsPages(itemsToIterate);
				break;
			case 'RISK': 
				itemsToIterate = ['ASSET_CLASS_CONFIG', 'CA_CONFIG', 'PRICE_MAINTENANCE', 'FIRM_LEVEL_LIQUIDITY', 'FIRM_LEVEL_SUSPENDED_STOCK', 'FLEX_FILES', 'TD_THRESHOLD'];
				this.getRiskPages(itemsToIterate);
				break;
			case 'NEWS_LETTER': itemsToIterate = ['NEWSLETTER_APPROVE','NEWSLETTER_MAPPING','NEWSLETTER_CREATE','NEWSLETTER_REPORTS','CREDIT_RATING'];
				this.getNewsLetterPages(itemsToIterate);
			    break;	
			case 'DMP': itemsToIterate = ['DATA_MARKET_PLACE']
				this.getDmpPages(itemsToIterate);
				break;
			case 'CONFIG': itemsToIterate = ['ENUM_CONFIG','SCHEDULER','CODE_CONFIG', 'TRANSLATION_DEFINITION'];
				this.getConfigPages(itemsToIterate);
				break;
			case 'D&C': itemsToIterate = ['DC_CONFIG','ACCOUNT_CONFIG','TRANSACTION_COST_CONFIG'];
			     this.getDcPages(itemsToIterate);
				 break;
			case 'QUANT': itemsToIterate = ['PREMIUM_DISCOUNT', 'PREMIUM_DISCOUNT_SUMMARY', 'DAILY_CR_ORDERS_MGMT', 'UPLOADED_FILES_LOG', 'TRANSACTION_SUMMARY',
				'QUANT_TRADE_DATES', 'QUANT_FX_RATE', 'QUANT_ADJUST_FAIR_VALUE', 'QUANT_ACC_MAPPING',
				'QUANT_BK_INTRST_MNTNCE', 'QUANT_FEE_MNTNCE', 'QUANT_EXP_FILES_LOG', 'PORTFOLIOCODE_MAPPING'];
				this.getQuantPages();
				break;
			case 'MANAGE': itemsToIterate = ['MANAGE_JOBS','AUDIT_TRAIL', 'MANAGE_USERS', 'USER_STATS',
				'MANAGE_ROLES', 'MANAGE_FUNDS','MAIL_CONFIG', 'EMAIL_GENERATION', 'FX_RATE', 'MANAGE_PEER_FUND', 'PRICES',
				'OPS_FX_RATES','HOLIDAY_CALENDER','PARTIES'];
				this.getSettingsPages(itemsToIterate);
				break;
			case 'P & L':
				itemsToIterate = ['FINANCE_AGGREGATE'];
				this.getPAndLPages(itemsToIterate);
				break;
			case 'EXT_AUM':
				itemsToIterate = ['EXT_AUM', 'AUM_QUERY'];
				this.getExtAumPages(itemsToIterate);
				break;
			case 'REPORT':
				itemsToIterate = ['REPORT'];
				this.getReportPages(itemsToIterate);
				break;
			case 'ETF_REBALANCE':
				itemsToIterate = ['ETF_REBALANCE'];
				this.getInvestPages(itemsToIterate);
				break;
			// CCASS-Sankey code
			case 'SALES_TEAM':
				itemsToIterate = ['DASHBOARD_CC_IFRAME']
				this.getSalesTeamPages();
				break;
			// IT menus
			case 'IT':
				itemsToIterate = ['DATA_MODULE', 'EOD_DISTRIBUTOR', 'MONITOR_DATA'];
				this.getItPages(itemsToIterate);
				break;
			case 'TPS':
				itemsToIterate = ['TPS','MESSAGE_HUB_CONFIG', 'TRADE_FILE_UPLOAD','TPS_CODE_CONFIG','TRADE_BLOTTER',
					'SECURITY_TYPE','FA_FUND_N_ACCOUNT','BROKER_SSI', 'TRADE_ELEMENT_CONFIG', 'EXCEPTION_MONITOR',
					'INSTRUCTIONS_CONFIG', 'FA_TEMPLATE_MAPPING_DEF', 'FORMAT_CODE_DEF', 'FORMAT_CODE_FIELD_DEF',
					'EXPORT_FILE', 'INSTRUCTION_DEF'
				];
				this.getTPSPages(itemsToIterate);
				break;
			default:
				break;
		}
		const privs: any = this.privilegeService.privs;
		for (let index = 0; index < itemsToIterate.length; index++) {
			const respectivePrv = itemsToIterate[index];
			if (privs[respectivePrv] !== undefined) { return true; }
		}
		return false;
	}

	isAllowedToViewMenuTPS(item: string) {
		const privs: any = this.privilegeService.privs;
		if (privs[item] !== undefined) { return true; }
		return false;
	}

	getTPSPages(itemsToIterate: any) {
		this.tpsPages = {
			tpsTradeBlotterPages: [],
			tpsStaticPages: [],
			tpsMessageHubPages: [],
			tpsConfigPages: []
		}
		this.pages.forEach((element: any) => {
			if (itemsToIterate.indexOf(element.priv) !== -1) {
				switch (element.priv) {
					case 'TRADE_BLOTTER':
					case 'EXCEPTION_MONITOR':
						this.tpsPages.tpsTradeBlotterPages.push(element)
						break
					case 'SECURITY_TYPE':
					case 'FA_FUND_N_ACCOUNT':
					case 'BROKER_SSI':
					case 'TPS_CODE_CONFIG':	
					case 'FA_TEMPLATE_MAPPING_DEF':
					case 'FORMAT_CODE_DEF':
					case 'FORMAT_CODE_FIELD_DEF':
					case 'EXPORT_FILE':
					case 'INSTRUCTION_DEF':
						this.tpsPages.tpsStaticPages.push(element)
						break
					case 'MESSAGE_HUB_CONFIG':
						this.tpsPages.tpsMessageHubPages.push(element)
						break
					case 'TRADE_ELEMENT_CONFIG':
					case 'INSTRUCTIONS_CONFIG':
						this.tpsPages.tpsConfigPages.push(element)
						break
					default:
						console.log('no match')
						break
				}
			}
		});
	}


	getRiskPages(itemsToIterate: any) {
		this.riskPages = [];
		this.pages.forEach((element: any) => {
			if (itemsToIterate.indexOf(element.priv) !== -1) {
				this.riskPages.push(element);
				this.setWelcomePage(element);
			}
		});
	}

	getNewsLetterPages(itemsToIterate: any) {
		this.newsLetterPages = [];
		this.pages.forEach((element: any) => {
			if (itemsToIterate.indexOf(element.priv) !== -1) {
				this.newsLetterPages.push(element);
				this.setWelcomePage(element);
			}
		});
	}

	getConfigPages(itemsToIterate: any) {
		this.configPages = [];
		this.pages.forEach((element: any) => {
			if (itemsToIterate.indexOf(element.priv) !== -1) {
				this.configPages.push(element);
				this.setWelcomePage(element);
			}
		})
	}

	getDcPages(itemsToIterate: any) {
		this.dcPages = [];
		this.pages.forEach((element: any) => {
			if(itemsToIterate.indexOf(element.priv) !== -1) {
				this.dcPages.push(element);
				this.setWelcomePage(element);
			}
		})
	}
	
	getDmpPages(itemsToIterate: any) {
		this.dmpPages = [];
		this.pages.forEach((element: any) => {
			if (itemsToIterate.indexOf(element.priv) !== -1) {
				this.dmpPages.push(element);
				this.setWelcomePage(element);
			}
		});
	}
	getOpsPages(itemsToIterate: any) {
		this.opsPages = [];

		this.pages.forEach((element: any) => {
			if (itemsToIterate.indexOf(element.priv) !== -1) {
				this.opsPages.push(element);
				// this.setWelcomePage(element);
			}
		});
	}

	getManageStaticData() {
		const manageStaticPages = ['FX_RATE', 'HOLIDAY_CALENDER'];
		this.manageStaticPages = [];
		this.pages.forEach((element: any) => {
			if (manageStaticPages.indexOf(element.priv) !== -1) {
				this.manageStaticPages.push(element);
				this.setWelcomePage(element);
			}
		});
	}

	getQuantPages() {
		const col1 = ['PREMIUM_DISCOUNT', 'PREMIUM_DISCOUNT_SUMMARY', 'DAILY_CR_ORDERS_MGMT'];
		const col2 = ['UPLOADED_FILES_LOG', 'PORTFOLIOCODE_MAPPING'];
		const col3 = ['TRANSACTION_SUMMARY'];
		this.quantPagescol1 = [];
		this.quantPagescol2 = [];
		this.quantPagescol3 = [];
		this.pages.forEach((element: any) => {
			if (col1.indexOf(element.priv) !== -1) {
				this.quantPagescol1.push(element);
				this.setWelcomePage(element);
			}
		});
		this.pages.forEach((element: any) => {
			if (col2.indexOf(element.priv) !== -1) {
				this.quantPagescol2.push(element);
				this.setWelcomePage(element);
			}
		});
		this.pages.forEach((element: any) => {
			if (col3.indexOf(element.priv) !== -1) {
				this.quantPagescol3.push(element);
				this.setWelcomePage(element);
			}
		});
	}

	fairvalueAdjustment() {
		this.fairvalue = true;
	}

	accountmaintainance() {
		this.accountmaintain = true;
	}

	fxRates() {
		this.isRates = true;
	}

	showFeeTypeToAccMaping() {
		this.showAccMaping = true;
	}

	showTradeDates() {
		this.isTradeDates = true;
	}

	getSettingsPages(itemsToIterate: any) {
		this.settingsPages = [];
		this.pages.forEach((element: any) => {
			if (itemsToIterate.indexOf(element.priv) !== -1) {
				this.settingsPages.push(element);
				if (!element.externalSso) {
					this.setWelcomePage(element);
				}
			}
		});
	}

	getPAndLPages(itemsToIterate: any) {
		this.pAndLPages = [];
		this.pages.forEach((element: any) => {
			if (itemsToIterate.indexOf(element.priv) !== -1) {
				this.pAndLPages.push(element);
				this.setWelcomePage(element);
			}
		});
	}

	getExtAumPages(itemsToIterate: any) {
		this.extAumPages = [];
		this.pages.forEach((element: any) => {
			if (itemsToIterate.indexOf(element.priv) !== -1) {
				this.extAumPages.push(element);
				this.setWelcomePage(element);
			}
		});
	}

	getReportPages(itemsToIterate: any) {
		this.reportPages = [];
		this.pages.forEach((element: any) => {
			if (itemsToIterate.indexOf(element.priv) !== -1) {
				this.reportPages.push(element);
				this.setWelcomePage(element);
			}
		});
	}

	getInvestPages(itemsToIterate: any) {
		this.investPages = [];
		this.pages.forEach((element: any) => {
			if (itemsToIterate.indexOf(element.priv) !== -1) {
				this.investPages.push(element);
				this.setWelcomePage(element);
			}
		});
	}

	getSalesTeamPages() {
		const pages = ['DASHBOARD_CC_IFRAME']
		this.salesTeamPages = [];
		this.pages.forEach((element: any) => {
			if (pages.indexOf(element.priv) !== -1) {
				this.salesTeamPages.push(element)
				this.setWelcomePage(element)
			}
		});
	}

	// IT sub pages
	getItPages(itemsToIterate: any) {
		this.itPages = [];
		this.pages.forEach((element: any) => {
			if (itemsToIterate.indexOf(element.priv) !== -1) {
				this.itPages.push(element);
				this.setWelcomePage(element);
			}
		});
	}

	// Set Default Home Page
	setDefaultHomePage(page: any) {
		this.confirmDefaultHome = true;
		this.selectedPage = page;
		this.customHeader = `<div style='opacity:0.7'>Do you want to save <b style='opacity: 1 !important;'>&nbsp;`
			+ page.label + `</b>&nbsp;page as Default Landing Page ?</div>`;
	}

	cancel() {
		this.selectedPage = null;
	}

	update() {
		this.loginUser['defaultWelcomePage'] = this.selectedPage.routerLink;
		this.authService.updateUserData(this.loginUser);
		this.isLoading = true;
		this.pageService.changeProfileData.next(this.loginUser);
		const obj = {
			'defaultWelcomePage': this.selectedPage.routerLink
		};
		this.defaultWelcomePage = this.selectedPage.routerLink;
		this.authService.update(obj).then(res => {
			this.isLoading = false;
			this.parentComponent.messageService.add({
				severity: 'success', detail: 'Updated ' + '<b>' + this.selectedPage.label +
					'</b>' + ' ' + 'as default landing page successfully.'
			});
		}).catch(err => {
			this.parentComponent.messageService.add({ severity: 'error', detail: err });
			this.isLoading = false;
		});
	}

	dontClose(event:any){
		event.preventDefault()
		event.stopPropagation()
	}
}
